import { AddBankAccountModal } from "@features/AddBankAccountModal/AddBankAccountModal";
import { useModalActions } from "@store/modal/modal";

export const useNewBankAccountModal = () => {
  const { create } = useModalActions();

  return (preselectedBankId?: number) => {
    create((modalProps) => (
      <AddBankAccountModal
        preselectedBankId={preselectedBankId}
        {...modalProps}
      />
    ));
  };
};
